<template>
  <b-container fluid v-if="comment" class="pt-2 mt-2 px-0" :id="'comment-' + comment.id">
    <b-row v-if="comment.deleted">
      <b-col :offset-sm="offset.sm" :offset-md="offset.md">
        <b-alert show variant="warning">Комментарий удален</b-alert>
      </b-col>
    </b-row>
    <template v-else>
      <b-row>
        <b-col sm="2" md="1" :offset-sm="offset.sm" :offset-md="offset.md" style="border-top: 1px dotted lightgray;" class="pt-1" :class="{'bg-author': isAuthor}">
          <b-img v-if="comment.author" :src="comment.author.avatar" rounded="circle" fluid></b-img>
        </b-col>
        <b-col style="border-top: 1px dotted lightgray;"  class="pt-1" :class="{'bg-author': isAuthor}">
          <small class="small float-right">{{ comment.published_at | small }}</small>
          <h5 v-if="comment.author">{{ comment.author.fullname }}</h5>
          <p class="mb-0" style="white-space: pre-line; word-break: break-all;" v-html="comment.message"></p>
        </b-col>
      </b-row>
      <template v-if="!frontend">
        <b-row v-if="!showForm">
          <b-col :offset-sm="offset.sm" :offset-md="offset.md" class="pb-1" :class="{'bg-author': isAuthor}">
            <b-button size="sm" variant="outline-danger" class="float-right ml-1" @click="deleteComment()" :disabled="deleting" v-b-tooltip="'Удалить'">
              <font-awesome-icon v-if="deleting" :icon="['fas', 'spinner']" spin></font-awesome-icon>
              <font-awesome-icon v-else :icon="['fas', 'trash-alt']"></font-awesome-icon>
            </b-button>
            <b-button size="sm" variant="outline-success" class="float-right" @click="showForm = true" v-b-tooltip="'Ответить'">
              <font-awesome-icon :icon="['fas', 'reply']"></font-awesome-icon>
            </b-button>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col :offset-sm="offset.sm + 2" :offset-md="offset.md + 1" class="mt-3">
            <comment-form :object="object" :type="type" :parent="comment" @close="showForm = false"></comment-form>
          </b-col>
        </b-row>
      </template>
    </template>

    <b-row v-if="!comment.empty">
      <b-col>
        <comment-block v-for="child in children" :key="child.id" :object="object" :type="type" :comment="child" :comments="comments" :level="level + 1" :frontend="frontend"></comment-block>
      </b-col>
      </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import { small } from '@/filters/date'
import CommentForm from '@/components/forms/Comment'

export default {
  name: 'comment-block',
  components: {
    CommentForm
  },
  filters: {
    small
  },
  props: {
    type: {
      type: String,
      required: true
    },
    object: {
      type: Object,
      required: true
    },
    comment: {
      type: Object,
      required: true
    },
    comments: {
      type: Array,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    frontend: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showForm: false,
    deleting: false,
    childrenUpdateTime: (new Date()).getTime()
  }),
  computed: {
    ...mapState('UserModule', {
      userId: state => state.id
    }),
    children () {
      return this.comments.filter(c => c.parent && (c.parent.id === this.comment.id))
    },
    offset () {
      const level = (this.level > 4) ? 4 : this.level
      return {
        sm: level * 2,
        md: level * 1
      }
    },
    isAuthor () {
      return this.comment && this.comment.author && (this.userId === this.comment.author.id)
    }
  },
  methods: {
    async deleteComment () {
      this.deleting = true
      await this.$store.dispatch('BlogModule/deleteComment', this.comment)
      this.deleting = false
    }
  }
}
</script>

<style lang="scss">
.bg-author {
  background-color: rgba(128,109,101,0.1);
}
</style>
